(() => {
  if (customElements.get('fc2-rail')) return;
  customElements.define('fc2-rail', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      let pointer = null;
      let suppressClick = false;
      const finish = () => {
        if (pointer && this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
        pointer = null;
        this.classList.remove('is-dragging');
      };
      this.addEventListener('keydown', event => {
        suppressClick = false;
        if (!['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
        event.preventDefault();
        this.scrollBy({
          left: (event.key === 'ArrowRight' ? 1 : -1) * this.clientWidth * .8,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }, options);
      this.addEventListener('dragstart', event => event.preventDefault(), options);
      this.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.scrollLeft, dragging: false };
      }, options);
      this.addEventListener('pointermove', event => {
        if (!pointer || pointer.id !== event.pointerId) return;
        if (!(event.buttons & 1)) { finish(); return; }
        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;
        if (!pointer.dragging && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          pointer.dragging = true;
          suppressClick = true;
          this.classList.add('is-dragging');
          this.setPointerCapture(event.pointerId);
        }
        if (pointer.dragging) {
          event.preventDefault();
          this.scrollLeft = pointer.left - dx;
        }
      }, options);
      this.addEventListener('pointerup', finish, options);
      this.addEventListener('pointercancel', finish, options);
      this.addEventListener('lostpointercapture', finish, options);
      this.addEventListener('click', event => {
        if (!suppressClick || event.detail === 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      }, { ...options, capture: true });
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.classList.remove('is-dragging');
    }
  });
})();